import { Component, input } from '@angular/core';
import { LoaderCircle, LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-login-loading',
  templateUrl: './login-loading.component.html',
  standalone: true,
  imports: [LucideAngularModule],
})
export class LoginLoadingComponent {
  readonly step = input<string>();
  protected readonly LoaderCircle = LoaderCircle;
}
